import { CompaniesWrapper } from "./styled";
import { useEffect, useState, useMemo } from "react";
import { Row } from "../../../../components/flex/styled";
import { BaseFieldSet } from "../../../../components/form/fieldset/styled";
import { BaseSelect } from "../../../../components/form/select/styled";
import { Label } from "../../../../components/typography/styled";
import { Span } from "../../../../components/typography/styled";
import { Table } from "../../../../components/table";
import Cookies from "universal-cookie";
import { getAllCompanies } from "../../../../utils/apis/company/getAllCompanies";
import { BaseInput } from "../../../../components/form/input/styled";
import { useNavigate } from "react-router-dom";
import { getAllPlans } from "../../../../utils/apis/plansandpricing/getAllPlans";
import { Layout } from "../../../../containers/app/layout";

export const Companies = () => {
  const PAGE_SIZE = 10;
  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");

  const navigate = useNavigate();

  const [companies, setCompanies] = useState([]);
  const [payrollPlans, setPayrollPlans] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({
    companyName: "",
    planType: "",
    usage: "",
  });

  useEffect(() => {
    getAllCompanies(TOKEN, filter)
      .then((data) => {
        setCompanies(data);
      })
      .catch((err) => {
        console.error("Failed to fetch companies:", err);
      });
  }, [TOKEN, filter]);

  useEffect(() => {
    getAllPlans(TOKEN)
      .then((data) => {
        setPayrollPlans(data ?? []);
      })
      .catch((err) => {
        console.error("Failed to fetch payroll plans:", err);
      });
  }, [TOKEN]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentPage(1);
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const totalCompanies = companies.length;
  const totalPages = Math.max(1, Math.ceil(totalCompanies / PAGE_SIZE));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const paginatedCompanies = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;
    return companies.slice(start, end);
  }, [companies, currentPage]);

  const visiblePageNumbers = useMemo(() => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }
    if (currentPage <= 2) {
      return [1, 2, 3];
    }
    if (currentPage >= totalPages - 1) {
      return [totalPages - 2, totalPages - 1, totalPages];
    }
    return [currentPage - 1, currentPage, currentPage + 1];
  }, [currentPage, totalPages]);

  const rangeStart =
    totalCompanies === 0 ? 0 : (currentPage - 1) * PAGE_SIZE + 1;
  const rangeEnd = Math.min(currentPage * PAGE_SIZE, totalCompanies);
  const companyCountText = totalCompanies === 1 ? "company" : "companies";

  const handleNavigateToCompanyDetailsPage = (e, companyId) => {
    e.stopPropagation();
    e.preventDefault();
    return navigate(`/admin/companies/${companyId}`);
  };

  return (
    <Layout id={"companies"} title={"Companies"}>
      <CompaniesWrapper>
        <Row className="heading-row" justifycontent={"space-between"}>
          <Span>Company List</Span>
          {/* <Span>Show all</Span> */}
        </Row>
        <Row className="filter">
          <BaseFieldSet>
            <Label>Company Name</Label>
            <BaseInput
              type="text"
              name="companyName"
              placeholder="Search by Company Name"
              value={filter.companyName}
              onChange={handleChange}
            />
          </BaseFieldSet>
          <BaseFieldSet>
            <Label>Plan Type</Label>
            <BaseSelect
              name="planType"
              value={filter?.planType}
              onChange={(e) => handleChange(e)}
            >
              <option value="" hidden>
                Select a Plan
              </option>
              {payrollPlans?.map((plan, index) => {
                return (
                  <option key={index} value={plan?.title}>
                    {plan?.title}
                  </option>
                );
              })}
            </BaseSelect>
          </BaseFieldSet>
          <BaseFieldSet>
            <Label>Usage</Label>
            <BaseSelect
              name="usage"
              onChange={handleChange}
              value={filter.usage}
            >
              <option value="">All time</option>
              <option value="last day">Last one day</option>
              <option value="last week">Last week</option>
              <option value="last month">Last month</option>
              <option value="last three month">Last three months</option>
              <option value="last six month">Last six months</option>
              <option value="last year">Last year</option>
            </BaseSelect>
          </BaseFieldSet>
        </Row>
        <div className="admin-table">
          <Table
            columnTitles={[
              "Company Name",
              "Employer's Name",
              "Plan Type",
              "Credits Left",
              "Last Used",
              "Action",
            ]}
            rowItems={paginatedCompanies}
            location={"Company Table"}
            handleRowItemClick={handleNavigateToCompanyDetailsPage}
          />
          <div className="table-footer">
            <span>
              Showing {rangeStart}-{rangeEnd} of {totalCompanies}{" "}
              {companyCountText}
            </span>
            <div className="pagination" aria-hidden="true">
              <button
                type="button"
                className="page-chip"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
              >
                &lt;
              </button>
              {visiblePageNumbers.map((pageNumber) => (
                <button
                  key={pageNumber}
                  type="button"
                  className={`page-chip ${currentPage === pageNumber ? "active" : ""}`}
                  onClick={() => setCurrentPage(pageNumber)}
                >
                  {pageNumber}
                </button>
              ))}
              <button
                type="button"
                className="page-chip"
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                }
              >
                &gt;
              </button>
            </div>
          </div>
        </div>
      </CompaniesWrapper>
    </Layout>
  );
};
